// src/components/lineage/traditionStyles.js
// Static class map for tradition colours, shared by the Lineage timeline and
// the thinker profile drawer. Classes must stay literal for the Tailwind JIT.
// Chip grounds are /70 and text is the -200 tier: the filter chips sit over
// the hero artwork, where the -300-on-/30 pairing measured 3.66:1 (EAA audit).
export const TRADITION_STYLES = {
  greek: { dot: 'bg-sky-500', text: 'text-sky-200', border: 'border-sky-400/30', chip: 'bg-sky-900/70' },
  // amber is the warmest hue here, so its text runs one tier lighter than the
  // rest: -200 measured 4.24:1 on the chip over the hero art; -100 clears 4.5.
  indian: { dot: 'bg-amber-500', text: 'text-amber-100', border: 'border-amber-400/30', chip: 'bg-amber-900/70' },
  chinese: { dot: 'bg-emerald-500', text: 'text-emerald-200', border: 'border-emerald-400/30', chip: 'bg-emerald-900/70' },
  islamic: { dot: 'bg-violet-500', text: 'text-violet-200', border: 'border-violet-400/30', chip: 'bg-violet-900/70' },
  european: { dot: 'bg-indigo-500', text: 'text-indigo-200', border: 'border-indigo-400/30', chip: 'bg-indigo-900/70' },
  african: { dot: 'bg-teal-500', text: 'text-teal-200', border: 'border-teal-400/30', chip: 'bg-teal-900/70' },
  modern: { dot: 'bg-rose-500', text: 'text-rose-200', border: 'border-rose-400/30', chip: 'bg-rose-900/70' }
};
